import { Pipe, PipeTransform } from '@angular/core';
import { CustomerStatus } from '../interfaces/interfaces';

@Pipe({
    name: 'customerstatus'
})
export class CustomerStatusPipe implements PipeTransform {
    transform(input: CustomerStatus): string {
        switch (input) {
            case CustomerStatus.ACTIVATED: return 'Aktivált';
            case CustomerStatus.DEACTIVATED: return 'Deaktivált';
            case CustomerStatus.NOT_ACTIVATED: return 'Nem aktivált';
        }
        return '-';
    }
}